import { callAPI } from './callAPI';
import { getFilterPostParams, getFilterQueryParams } from './storageManager'

const MEDIA_ENDPOINT = '/front/media';
export const DEFAULT_MEDIA_PRIVATE = true;

const getMediaEndpoint = (id) => `${MEDIA_ENDPOINT}/${encodeURIComponent(id)}`;

const getQueryAppParams = (app) => {
    const appId = Number(app);
    return Number.isInteger(appId) && appId > 0 ? { app_id: appId } : {};
};

const appendMediaFormField = (formData, key, value) => {
    if (value === undefined || value === null) return;

    if (value instanceof Blob) {
        formData.append(key, value);
        return;
    }

    if (typeof value === 'object') {
        formData.append(key, JSON.stringify(value));
        return;
    }

    formData.append(key, String(value));
};

const buildMediaFormData = (file, data = {}) => {
    if (file instanceof FormData) {
        if (!file.has('private')) {
            appendMediaFormField(file, 'private', DEFAULT_MEDIA_PRIVATE);
        }
        return file;
    }

    const formData = new FormData();
    appendMediaFormField(formData, 'file', file);
    Object.entries({
        ...data,
        private: data.private ?? DEFAULT_MEDIA_PRIVATE
    }).forEach(([key, value]) => {
        appendMediaFormField(formData, key, value);
    });

    return formData;
};

/////////////////////
// App arborescence
/////////////////////

export const getMenu = async (app) => {
    try {
        const response = await callAPI.get(`/front/menu/${app}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching menu:', error);
        throw error;
    }
};

export const getPageByID = async (id) => {
    try {
        const response = await callAPI.get(`/front/menu/page/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching app:', error);
        throw error;
    }
};

/////////////////////
// Front API calls
/////////////////////

export const getClientRoles = async (clientId) => {
    if (!clientId) return [];
    try {
        const client = await getClient(clientId);
        if (client && client.client_apps) {
            try {
                // Supposant que client_apps est une chaîne JSON
                return JSON.parse(client.client_apps);
            } catch (e) {
                console.error("Failed to parse client_apps JSON:", e);
                return []; // Retourne un tableau vide si le parsing échoue
            }
        }
        return [];
    } catch (error) {
        console.error(`Error fetching roles for client ${clientId}:`, error);
        throw error;
    }
};

export const getEntityList = async (parentIdArray, type) => {
    var parent_id
    if (parentIdArray && parentIdArray.length) {
        parent_id = parentIdArray.join(',');
    }
    try {
        const response = await callAPI.get("/front/combos/entities", {
            params: { parent_id, type }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching entity list:', error);
        throw error;
    }
};

export const getGroupList = async (parentIdArray, type) => {
    var parent_id
    if (parentIdArray && parentIdArray.length) {
        parent_id = parentIdArray.join(',');
    }
    try {
        const response = await callAPI.get("/front/combos/groups", {
            params: { parent_id, type }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching group list:', error);
        throw error;
    }
};

export const getSimpleList = async (app, tableName, labelField) => {
    try {
        const response = await callAPI.get(`/front/combos/list/${app}/${tableName}`, {
            params: { labelField }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching simple list:', error);
        throw error;
    }
};

export const getFiltersList = async (app, filterGroupName) => {
    try {
        const response = await callAPI.get(`/front/combos/filter/${filterGroupName}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching simple list:', error);
        throw error;
    }
};

export const getAirDnaCity = async () => {
    try {
        const response = await callAPI.get("/front/combos/city");
        return response.data;
    } catch (error) {
        console.error('Error fetching city list:', error);
        throw error;
    }
};

export const getQueryInfos = async (name, category, app = null) => {
    const encodedName = encodeURIComponent(name);
    const encodedCategory = category ? `/${encodeURIComponent(category)}` : '';

    try {
        const response = await callAPI.get(`/front/query/${encodedName}${encodedCategory}`, {
            params: getQueryAppParams(app)
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching query infos:', error);
        throw error;
    }
};

export const getQueryList = async () => {
    try {
        const response = await callAPI.get(`/front/query`);
        return response.data;
    } catch (error) {
        console.error('Error fetching query infos:', error);
        throw error;
    }
};

export const getRawData = async (app, query, category, params = null) => {
    var url = `/front/display/data/${query}/${category}`;
    var body = getFilterPostParams(app);
    var queryParams = getFilterQueryParams(query);
    if (queryParams) {
        body = { ...body, ...queryParams };
    }
    if (params) {
        body = { ...body, ...params };
    }
    console.log(query, category, body);
    try {
        const response = await callAPI.post(
            url,
            body,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                params: getQueryAppParams(app)
            }
        );
        return [response.data, url, body];
    } catch (error) {
        console.error('Error fetching data from DB:', error);
        // throw error;
        return [error, url, body];
    }
};

export const getAllowedApps = async () => {
    try {
        const response = await callAPI.get(`/front/combos/apps`);
        return response.data;
    } catch (error) {
        console.error('Error fetching menu:', error);
        throw error;
    }
};

export const getMediaTypes = async (params = {}) => {
    try {
        const response = await callAPI.get('/admin/media/types', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching media types:', error);
        throw error;
    }
};

/////////////////////
// User media
/////////////////////

export const getMediaList = async (params = {}) => {
    try {
        const response = await callAPI.get(MEDIA_ENDPOINT, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching media list:', error);
        throw error;
    }
};

export const getMedia = async (id) => {
    try {
        const response = await callAPI.get(getMediaEndpoint(id));
        return response.data;
    } catch (error) {
        console.error(`Error fetching media ${id}:`, error);
        throw error;
    }
};

export const uploadMedia = async (file, data = {}, onUploadProgress = null) => {
    const formData = buildMediaFormData(file, data);
    const config = onUploadProgress ? { onUploadProgress } : {};

    try {
        const response = await callAPI.post(MEDIA_ENDPOINT, formData, config);
        return response.data;
    } catch (error) {
        console.error('Error uploading media:', error);
        throw error;
    }
};

export const createMedia = uploadMedia;

export const updateMedia = async (id, data) => {
    try {
        const response = await callAPI.patch(getMediaEndpoint(id), data);
        return response.data;
    } catch (error) {
        console.error(`Error updating media ${id}:`, error);
        throw error;
    }
};

export const saveMediaPreferences = async (id, prefs) => {
    return updateMedia(id, { prefs });
};

export const deleteMedia = async (id) => {
    try {
        const response = await callAPI.delete(getMediaEndpoint(id));
        return response.data;
    } catch (error) {
        console.error(`Error deleting media ${id}:`, error);
        throw error;
    }
};

export const downloadMedia = async (id) => {
    try {
        const response = await callAPI.get(`${getMediaEndpoint(id)}/download`, {
            responseType: 'blob'
        });
        return response.data;
    } catch (error) {
        console.error(`Error downloading media ${id}:`, error);
        throw error;
    }
};
